import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import MasterTable from "../common/MasterTable";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import Loader from "../Loader/Loader";
import { format, parse } from "date-fns";
import SmsDownloadReport from "./SmsDownloadReport";
import SMSHistoryFilterModal from "./SmsHistoryFilterModal";
import { useSelector, useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import Swal from "sweetalert2";
import { IoEyeOutline } from "react-icons/io5";
import ReportModal from "./Report";
import TrafficReportStatement from "./TrafficReportModal";
import confetti from "canvas-confetti";
import FullStatement from "../transactionReport/FullStatement";

const today = new Date().toISOString().split("T")[0];

const defaultFilterData = {
  userCode: "",
  mobileNo: "",
  status: [],
  fromDate: today,
  toDate: today,
  operator: [],
  customerName: "",
  bulkFileId: "",
};

const SmsHistory = () => {
  const loggedInUserName = sessionStorage.getItem("username");
  const { user } = useSelector((state) => state.auth);
  const userRole = sessionStorage.getItem("userRole");
  const [searchParams] = useSearchParams();
  const isADMK = userRole !== "CUST";
  const dispatch = useDispatch();

  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [SMSHistoryData, setSMSHistoryData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpenSms, setIsModalOpenSms] = useState(false);
  const [isModalOpenSmsDown, setIsModalOpenSmsDown] = useState(false);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [isReportModal, setIsReportModal] = useState(false);
  const [isTrafficReportModal, setIsTrafficReportModal] = useState(false);
  const [filterData, setFilterData] = useState(() => {
    const queryStatus = searchParams.get("status");
    const queryBulkFileId = searchParams.get("bulkFileId");
    return {
      ...defaultFilterData,
      status: queryStatus ? [queryStatus] : defaultFilterData.status,
      bulkFileId: queryBulkFileId || defaultFilterData.bulkFileId,
    };
  });
  const [loadingFullSt, setLoadingFullSt] = useState(false);

  const openModalSms = () => {
    setIsModalOpenSms(true);
  };

  const closeModalSms = () => {
    setIsModalOpenSms(false);
  };

  const openModalSmsDown = () => {
    setIsModalOpenSmsDown(true);
  };

  const closeModalSmsDown = () => {
    setIsModalOpenSmsDown(false);
  };

  const openModalTrafficReport = () => {
    setIsTrafficReportModal(true);
  };

  const closeModalTrafficReport = () => {
    setIsTrafficReportModal(false);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
    setCurrentPage(1);
  };

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data?.balanceDetails));
        } else {
          console.warn("Dashboard data fetch failed:", response?.data?.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
      });
  };

  useEffect(() => {
    fetchSMSHistoryData(1, filterData);
  }, []);

  const fetchSMSHistoryData = async (pageNo, filters) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        companyCode: filters.userCode || "",
        mobileNo: filters.mobileNo || "",
        status: filters.status || [],
        bulkFileId: filters.bulkFileId || "",
        responseTxnId: "",
        rrn: "",
        transactionType: "",
        vendorType: "",
        fromDate: filters.fromDate
          ? format(
              parse(filters.fromDate, "yyyy-MM-dd", new Date()),
              "dd-MM-yyyy",
            )
          : "",

        toDate: filters.toDate
          ? format(
              parse(filters.toDate, "yyyy-MM-dd", new Date()),
              "dd-MM-yyyy",
            )
          : "",

        otp: filters.operator || [],
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_SMS_MASTER}?pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody,
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setSMSHistoryData(modifiedData);
        setNoData(modifiedData?.length === 0);
        fetchDashboardData();
      } else {
        setNoData(true);
        setSMSHistoryData([]);
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setSMSHistoryData([]);
      setNoData(true);
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const otpDateParsed = user?.otpDate
        ? parse(user.otpDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const respDateParsed = user?.responseDate
        ? parse(user.responseDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedPaymentAmount =
        user?.paymentAmount !== undefined
          ? Number(user.paymentAmount).toFixed(2)
          : "";

      const formattedWalletBalance =
        user?.walletBalance !== undefined
          ? Number(user.walletBalance).toFixed(2)
          : "";

      const formattedRrn = user?.rrn ? (
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          {user?.rrn}
        </td>
      ) : (
        ""
      );

      const formattedReqTxnNo = user?.reqTxnNo ? (
        <span
          style={{
            whiteSpace: "nowrap",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          {user.reqTxnNo.length > 10
            ? `${user.reqTxnNo.substring(0, 10)}…`
            : user.reqTxnNo}
          <IoEyeOutline
            style={{
              marginLeft: 6,
              cursor: "pointer",
              verticalAlign: "middle",
              fontSize: 22,
              color: "#00b6ce",
            }}
            title="View full SMS ID"
            onClick={() =>
              Swal.fire({
                title: "SMS ID",
                text: user.reqTxnNo,
                confirmButtonText: "Close",
              })
            }
          />
        </span>
      ) : (
        ""
      );

      return {
        ...user,
        id: index + 1,
        otpDate: otpDateParsed
          ? [
              format(otpDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(otpDateParsed, "HH:mm:ss"),
            ]
          : "",

        responseDate: respDateParsed
          ? [
              format(respDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(respDateParsed, "HH:mm:ss"),
            ]
          : "",

        paymentAmount: formattedPaymentAmount,
        walletBalance: formattedWalletBalance,
        rrn: formattedRrn ? formattedRrn : "",
        reqTxnNo: formattedReqTxnNo ? formattedReqTxnNo : "",
      };
    });

    return modified;
  };

  const SMSHistoryHeaders = isADMK
    ? [
        "Status",
        "Response",
        "Request Date",
        "Response Date",
        "PDU_Count",
        "Current Balance(Qty)",
        "Dr/Cr",
        "Mobile Number",
        "Company ID",
        "Company Name",
        "SMS ID",
        "Message",
      ]
    : [
        "Status",
        "Request Date",
        "Response Date",
        "PDU_Count",
        "Mobile Number",
        // "Company ID",
        // "Company Name",
        "SMS ID",
        "Message",
      ];

  const SMSHistoryHeaderToKeyMap = isADMK
    ? {
        Status: "status",
        Response: "smsResponse",
        "Request Date": "otpDate",
        "Response Date": "responseDate",
        PDU_Count: "pduCount",
        "Current Balance(Qty)": "newSms",
        "Dr/Cr": "transactionType",
        "Mobile Number": "mobileNo",
        "Company ID": "username",
        "Company Name": "companyName",
        "SMS ID": "sendTxnId",
        "Message": "sms",
      }
    : {
        Status: "status",
        "Request Date": "otpDate",
        "Response Date": "responseDate",
        PDU_Count: "pduCount",
        "Mobile Number": "mobileNo",
        // "Company ID": "username",
        // "Company Name": "companyName",
        "SMS ID": "sendTxnId",
        "Message": "sms",
      };

  const handlerSMSHistory = (id, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "reload") {
      fetchSMSHistoryData(pageDetails?.pageNo, filterData, actionType);
    } else if (actionType === "report") {
      setIsReportModal(true);
    }
  };

  const handleFullStatement = async (
    fromDate,
    toDate,
    operatorType,
    reportType,
  ) => {
    try {
      setLoadingFullSt(true);
      const payload = {
        username: user?.data?.username,
        fromDate,
        toDate,
        otp: operatorType,
        reportType: reportType ? reportType : "Full Statement",
      };

      const response = await axiosPostApi(
        `${apiList.SMS_FULL_STATEMENT_HISTORY}`,
        payload,
      );

      if (response.status === 200 && response.data.status === true) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message || "Success",
          icon: "success",
          confirmButtonText: "Ok",
        });
        closeModalSms();
        closeModalTrafficReport();
        setIsReportModal(false);

        const canvas = document.createElement("canvas");
        canvas.style.position = "fixed";
        canvas.style.top = "0";
        canvas.style.left = "0";
        canvas.style.width = "100%";
        canvas.style.height = "100%";
        canvas.style.zIndex = "3000";
        document.body.appendChild(canvas);

        const confettiInstance = confetti.create(canvas, {
          resize: true,
          useWorker: true,
        });

        confettiInstance({
          particleCount: 250,
          spread: 100,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          document.body.removeChild(canvas);
        }, 3000);
      } else {
        // setNoData(true);
        // fetchSMSHistoryData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "Failed",
            text: response?.data?.message || "Failed",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
      setLoadingFullSt(false);
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while processing.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoadingFullSt(false);
    }
  };

  const pageSizeCount = pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={SMSHistoryHeaders}
            data={SMSHistoryData}
            handleAction={handlerSMSHistory}
            filterFields={["userCode"]}
            entityType="SMS Transaction"
            headerToKeyMap={SMSHistoryHeaderToKeyMap}
            loading={loading}
            pageDetails={pageDetails}
            noData={noData}
            currentPage={currentPage}
            pageSize={pageSize}
            totalRecord={totalRecord}
            handleReset={handleReset}
            fetchNextData={(pageNo) => fetchSMSHistoryData(pageNo, filterData)}
            setCurrentPage={setCurrentPage}
            openModalFilter={openModalFilter}
            openModalSms={openModalSms}
            openModalSmsDown={openModalSmsDown}
            fetchData={() => fetchSMSHistoryData(1, defaultFilterData)}
            filterData={filterData}
          />
        </>
      )}
      {isModalOpenFilter ? (
        <SMSHistoryFilterModal
          show={isModalOpenFilter}
          handleClose={closeModalFilter}
          setFilterData={setFilterData}
          filterData={filterData}
          handleReset={handleReset}
          setHistoryData={setSMSHistoryData}
          setPageDetails={setPageDetails}
          setNoData={setNoData}
          currentPage={currentPage}
          pageSize={pageSize}
        />
      ) : null}
      {isModalOpenSms ? (
        <FullStatement
          handleopenReport={isModalOpenSms}
          handleCloseReport={closeModalSms}
          callApi={handleFullStatement}
          loading={loadingFullSt}
          backBtn
        />
      ) : null}
      {isModalOpenSmsDown ? (
        <SmsDownloadReport
          handleopenSmsDown={isModalOpenSmsDown}
          handleCloseSmsDown={closeModalSmsDown}
        />
      ) : null}
      {isTrafficReportModal ? (
        <TrafficReportStatement
          handleopenReport={isTrafficReportModal}
          handleCloseReport={closeModalTrafficReport}
          callApi={handleFullStatement}
          loading={loadingFullSt}
        />
      ) : null}
      {isReportModal ? (
        <ReportModal
          show={isReportModal}
          handleClose={() => {
            setIsReportModal(false);
          }}
          openFullStatement={openModalSms}
          openTrafficReport={openModalTrafficReport}
          reportOptions={[
            { value: "statement", label: "Full Statement" },
            { value: "traffic", label: "Traffic Report" },
          ]}
          onSubmitReportType={(type) => console.log("Selected:", type)}
        />
      ) : null}
    </div>
  );
};

export default SmsHistory;
